import { Grid, Typography } from "@mui/material";
import DividerCustom from "../components/DividerFund";
import { TextBoxItem } from "components/Input/TextBox";
import { FormProvider } from "react-hook-form";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { BtnAdd, BtnBack, BtnEdit, BtnSave } from "components/Button/ButtonAll";
import { TextAreaItem } from "components/Input/TextArea";
import { DefaultArrayEmpty, Extension, I18n } from "utilities/utilities";
import UploadFile from "components/Input/UploadFile";
import { ParseHtml } from "utilities/utilities";
import {
  useActivityGrid,
  useActivityOtherGrid,
  useFollowUpReview,
} from "../hooks/useFollowUp";
import DataGrid from "components/DataGrid";
import { CheckBoxItem } from "components/Input/Checkbox/CheckBoxItem";
import { SelectItem } from "components/Input/Select/SelectItem";
import { useLocation } from "react-router";
import InputNumberItem from "components/Input/InputNumber";
import TimePicker from "../TimePicker";
import moment from "moment";
import InputReactNumber from "view/Backend/IncomeExpenses/InputReactNumber";

const FollowUpReview = () => {
  const location = useLocation();
  const searchParams = location.search;
  const sActivityID = new URLSearchParams(searchParams).get("sActivityID");

  const {
    form,
    dataRow,
    arrFileActivityList,
    setArrFileActivityList,
    onClearFile,
    onClearFileUnplan,
    isOther,
    handleChangeOther,
    formOther,
    arrFileActivityOtherList,
    setArrFileActivityOtherList,
    dataRowOther,
    activityID,
    onAddActivity,
    objData,
    handleEdit,
    handleDelete,
    activityOtherID,
    onAddActivityOther,
    handleEditOther,
    handleDeleteOther,
    arrTypeUnplan,
    arrGroupUnplan,
    arrTaskUnplan,
    handleChangeUnplan,
    isOtherTask,
    handleChangeTime,
    nHour,
    onBack,
    handleSubmit,
    nMax,
    nMin,
    setNMax,
    setNMin,
    CheckWeightActivity,
    isPermission
  } = useFollowUpReview(sActivityID);
  const dataColumn = useActivityGrid(handleEdit, handleDelete, !isPermission);
  const dataOtherColumn = useActivityOtherGrid(handleEditOther, handleDeleteOther, !isPermission);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 500,
            color: "#1256bc",
            textAlign: "center",
          }}
        >
          การรายงานผลปฎิบัติการ
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">วิสัยทัศน์</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sVision}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">พันธกิจ</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sMission}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">เป้าประสงค์</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sGoal)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">ยุทธศาสตร์ที่ {objData.sOrderStrategic}</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sStrategic}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              เป้าประสงค์เชิงยุทธศาสตร์
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sTarget)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">กลยุทธ์ที่ {objData.sOrderStrategy}</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sStrategy}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">โครงการ</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sProject}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">กิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sActivity}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">อยู่ภายใต้กิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            {DefaultArrayEmpty(objData.lstSubActivity).map((activity) => (
              <Typography key={"sub_" + activity}>{ParseHtml(activity)}</Typography>
            ))}
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              {I18n.SetText("FundPlan.Duration")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sDuration}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              อ้างอิงตัวชี้วัด (กรมบัญชีกลาง)
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sIndicator)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">ค่าน้ำหนักกิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sWeight}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 500,
            color: "#4992ff",
          }}
        >
          การรายงานผล
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormProvider {...form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DividerCustom txt="รายงานผลกิจกรรม" className="divider-chip" />
            </Grid>
            <Grid item xs={12}>
              <TextBoxItem
                name="sTopic"
                label="ชื่อกิจกรรม"
                required={false}
                maxLength={250}
                IsShowTextCont
                disabled
              />
            </Grid>
            {isPermission &&
              <>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={3.5}>
                      <Typography className="font-medium">
                        {I18n.SetText("FundPlan.Duration")}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.25}>
                      <DatePickerItem
                        name="sDateStart"
                        label="วันที่เริ่มต้น"
                        IsDisablePortal
                        required
                        maxDate={nMax}
                        onChange={(e) => {
                          setNMin(e)
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={0.5}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Typography className="font-medium text-center">
                        -
                      </Typography>
                    </Grid>
                    <Grid item xs={2.25}>
                      <DatePickerItem
                        name="sDateEnd"
                        label="วันที่สิ้นสุด"
                        IsDisablePortal
                        required
                        onChange={(e) => {
                          setNMax(e)
                        }}
                        minDate={nMin}
                        maxDate={moment()}
                      />
                    </Grid>
                    <Grid item xs={3.5}>
                      <InputReactNumber
                        id={`sWeight`}
                        name={`sWeight`}
                        required
                        max={100}
                        type={"Number"}
                        maxDigits={2}
                        label="รายงานตัวเลข (ร้อยละ)"
                        onChange={(e) => CheckWeightActivity(e)}
                        ShowDigits={2}
                        IsCanMinus={false}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                  <Grid container spacing={2} justifyContent={"flex-end"}>
                    <Grid item xs={8.5}>
                      <TextAreaItem
                        name="sRemark"
                        label="หมายเหตุ"
                        required={false}
                        maxLength={250}
                        IsShowTextCont
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                  {activityID === "" ? (
                    <BtnAdd
                      id="Add"
                      txt="เพิ่ม"
                      onClick={form.handleSubmit(() => {
                        onAddActivity();
                      })}
                    />
                  ) : (
                    <BtnEdit
                      id="Edit"
                      txt="แก้ไข"
                      onClick={form.handleSubmit(() => {
                        onAddActivity();
                      })}
                    />
                  )}
                </Grid>
              </>
            }
            <Grid item xs={12}>
              <DataGrid
                sTableID="tableFollowUpReview"
                columns={dataColumn}
                rows={dataRow}
                modeFilter={0}
                isLoading={false}
                onLoadData={(e) => { }}
                isShowCheckBox={false}
                onDelete={() => { }}
                isHiddenToolHead
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className="font-medium">หลักฐาน/เอกสารแนบ</Typography>
            </Grid>
            <Grid item xs={12}>
              <UploadFile
                id="sDocFile_Activity"
                name={"arrActivityFile"}
                key={"sDocFile_Activity"}
                IsDrag={true}
                arrFile={arrFileActivityList}
                setarrFile={setArrFileActivityList}
                IsFolder={false}
                IsMultiple={true}
                Extension={[...Extension.FileTicket, ...Extension.Word]}
                nLimitFile={30}
                sLimitFile={"MB"}
                onClearFile={onClearFile}
                modeDisplay={"list"}
                sFolderTemp={"FundWork"}
                IsDragDrop={false}
                IsCrop={false}
                sPositionText={"right"}
                required={true}
                disabled={!isPermission}
              />
            </Grid>
          </Grid>
        </FormProvider>
      </Grid>
      <Grid item xs={12}></Grid>
      <FormProvider {...formOther}>
        <Grid item xs={12}>
          <CheckBoxItem
            name="isOther"
            options={[
              {
                value: "true",
                label: "การปฎิบัติงานเพิ่มเติมนอกเหนือเเผน (ถ้ามี)",
              },
            ]}
            onChange={(e) => handleChangeOther(e)}
            disabled={!isPermission}
          />
        </Grid>
        {isOther && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <DividerCustom
                  txt="การปฎิบัติงานเพิ่มเติมนอกเหนือเเผน"
                  className="divider-chip"
                />
              </Grid>

              {isPermission &&
                <>
                  <Grid item xs={12} md={7}>
                    <SelectItem
                      name="sWorkType"
                      label={I18n.SetText("FundPlan.TypeTask")}
                      placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.TypeTask")}`}
                      required
                      options={arrTypeUnplan}
                      onChange={(e) => {
                        handleChangeUnplan(e, "type");
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7} display={arrGroupUnplan.length > 0 ? "block" : "none"}>
                    <SelectItem
                      name="sMeetingGroup"
                      label={`${I18n.SetText("FundPlan.GroupMeeting")}/${I18n.SetText("FundPlan.Task")}`}
                      placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.GroupMeeting")}/${I18n.SetText("FundPlan.Task")}`}
                      required={arrGroupUnplan.length > 0}
                      options={arrGroupUnplan}
                      onChange={(e) => {
                        handleChangeUnplan(e, "group");
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7} display={arrTaskUnplan.length > 0 ? "block" : "none"}>
                    <SelectItem
                      name="sOperation"
                      label={I18n.SetText("FundPlan.Task")}
                      placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.Task")}`}
                      required={arrTaskUnplan.length > 0}
                      options={arrTaskUnplan}
                    />
                  </Grid>
                  {isOtherTask &&
                    <Grid item xs={12} md={7}>
                      <TextBoxItem
                        name="sOtherTask"
                        label={`${I18n.SetText("FundPlan.Fill")}${I18n.SetText("FundPlan.OtherTask")}`}
                        required
                        maxLength={250}
                        IsShowTextCont
                      />
                    </Grid>
                  }
                  <Grid item xs={12}>
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                      <Grid item xs={3.5}>
                        <Typography className="font-medium">
                          {I18n.SetText("FundPlan.Duration")}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <DatePickerItem
                          name="sDate"
                          label="วันที่"
                          IsDisablePortal
                          required={true}
                          maxDate={moment()}
                          onChange={(e) => { }}
                        />
                      </Grid>
                      <Grid item xs={1}></Grid>
                      <Grid item xs={2}>
                        <TimePicker
                          name={"tTimestart"}
                          label={"เวลาเริ่มต้น"}
                          required={true}
                          disabled={false}
                          icon={"pi pi-clock"}
                          iconPosition="right"
                          showIcon={true}
                          onChange={(e) => {
                            handleChangeTime("s", e);
                          }}

                        />

                      </Grid>
                      <Grid item xs={2}>
                        <TimePicker
                          name={"tTimeend"}
                          label={"เวลาสิ้นสุด"}
                          onChange={(e) => {
                            handleChangeTime("e", e);
                          }}
                          required={true}
                          disabled={false}
                          icon={"pi pi-clock"}
                          iconPosition="right"
                          showIcon={true}
                        />
                      </Grid>
                      <Grid item xs={1.5}>
                        <Typography className="font-medium">{nHour} ชม.</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className="font-medium">
                      หลักฐาน/เอกสารแนบ
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <UploadFile
                      id="sDocFile_ActivityOther"
                      name={"arrActivityOtherFile"}
                      key={"sDocFile_ActivityOther"}
                      IsDrag={true}
                      arrFile={arrFileActivityOtherList}
                      setarrFile={setArrFileActivityOtherList}
                      IsFolder={false}
                      IsMultiple={true}
                      Extension={[...Extension.FileTicket, ...Extension.Word]}
                      nLimitFile={30}
                      sLimitFile={"MB"}
                      onClearFile={onClearFileUnplan}
                      modeDisplay={"list"}
                      sFolderTemp={"FundWork"}
                      IsDragDrop={false}
                      IsCrop={false}
                      sPositionText={"right"}
                      required={true}
                      disabled={!isPermission}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{ mt: 1 }}
                    display={"flex"}
                    justifyContent={"right"}
                  >
                    {activityOtherID === "" ? (
                      <BtnAdd
                        id="Add"
                        txt="เพิ่มงาน"
                        onClick={formOther.handleSubmit(() => {
                          onAddActivityOther();
                        }, (err) => {
                        })}
                      />
                    ) : (
                      <BtnEdit
                        id="Edit"
                        txt="แก้ไขงาน"
                        onClick={formOther.handleSubmit(() => {
                          onAddActivityOther();
                        }, (err) => {
                        })}
                      />
                    )}
                  </Grid>
                </>
              }
              <Grid item xs={12}>
                <DataGrid
                  sTableID="tableActivityOther"
                  columns={dataOtherColumn}
                  rows={dataRowOther}
                  modeFilter={0}
                  isLoading={false}
                  onLoadData={(e) => { }}
                  isShowCheckBox={false}
                  onDelete={() => { }}
                  isHiddenToolHead
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </FormProvider>
      {/* button action */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <BtnBack
              id="back"
              onClick={onBack}
            />
          </Grid>
          {isPermission &&
            <Grid item xs={6}>
              <Grid container display={"flex"} justifyContent={"flex-end"} spacing={1} >
                <Grid item>
                  <BtnSave
                    id="save"
                    onClick={handleSubmit}
                  />
                </Grid>
              </Grid>
            </Grid>
          }
        </Grid>
      </Grid>
    </Grid >
  );
};

export default FollowUpReview;
